import React from 'react';
import { useAuth } from '../contexts/AuthContext';

/**
 * Contenedor centrado: todos los roles usan ancho limitado (no pantalla completa).
 * PERSONAL: un poco más estrecho; JEFE/ADMIN: hasta 1200px.
 */
const AppPageLayout = ({ children }) => {
  const { user } = useAuth();
  const isPersonal = user?.rol === 'PERSONAL';

  const className = isPersonal
    ? 'app-page-layout app-page-layout--personal'
    : 'app-page-layout app-page-layout--constrained';

  return <div className={className}>{children}</div>;
};

export default AppPageLayout;
